"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.COOKIE_PL_USER_ID = exports.COOKIE_STYTCH_SESSION = exports.COOKIE_CHORD_USER_ID = exports.SENTRY_ERRORS = void 0;
exports.SENTRY_ERRORS = {
    STYTCH_AUTHORIZATION_MAX_RETRIES: 'STYTCH_AUTHORIZATION_MAX_RETRIES',
    STYTCH_AUTHORIZATION_REDIRECT: 'STYTCH_AUTHORIZATION_REDIRECT',
    GET_USER_CREDIT_ERROR: 'GET_USER_CREDIT_ERROR',
    REPORTS_ERROR: 'REPORTS_ERROR',
    REDEEM_PURCHASE_ERROR: 'REDEEM_PURCHASE_ERROR',
    GET_CUSTOMER_PURCHASES_ERROR: 'GET_CUSTOMER_PURCHASES_ERROR',
    FINALIZE_CHECKOUTS_ERROR: 'FINALIZE_CHECKOUTS_ERROR',
    FINALIZE_ORDER_ERROR: 'FINALIZE_ORDER_ERROR',
    INVALID_SKU_VALUE_ERROR: 'INVALID_SKU_VALUE_ERROR',
    QUICK_CHECKOUTS_ERROR: 'QUICK_CHECKOUTS_ERROR',
    REPORTS_POST_ERROR: 'REPORTS_POST_ERROR',
    SYNTAX_ERROR_FROM_SERVER: 'SYNTAX_ERROR_FROM_SERVER',
    FROM_PARAMS_ERROR: 'FROM_PARAMS_ERROR',
    FETCH_IMAGE_ERROR: 'FETCH_IMAGE_ERROR',
    FETCH_ORDER_ERROR: 'FETCH_ORDER_ERROR',
    IMAGE_UPLOAD_ERROR: 'IMAGE_UPLOAD_ERROR',
    IMAGE_FETCH_ERROR: 'IMAGE_FETCH_ERROR',
    UPDATE_METADATA_ERROR: 'UPDATE_METADATA_ERROR',
    UNABLE_TO_REDEEM_ORDER: 'UNABLE_TO_REDEEM_ORDER',
    UNABLE_TO_CREATE_REPORT: 'UNABLE_TO_CREATE_REPORT',
    UNABLE_TO_FULFILL_ORDER_PLACE_INVALID: 'UNABLE_TO_FULFILL_ORDER_PLACE_INVALID',
    UNABLE_TO_FULFILL_ORDER: 'UNABLE_TO_FULFILL_ORDER',
    DIGITAL_PURCHASE_FETCH_ERROR: 'DIGITAL_PURCHASE_FETCH_ERROR',
    DIGITAL_PURCHASE_UPDATE_ERROR: 'DIGITAL_PURCHASE_UPDATE_ERROR',
    DIGITAL_PURCHASE_METADATA_UPDATE_ERROR: 'DIGITAL_PURCHASE_METADATA_UPDATE_ERROR',
};
exports.COOKIE_CHORD_USER_ID = 'chord_user_id';
exports.COOKIE_STYTCH_SESSION = 'stytch_session';
exports.COOKIE_PL_USER_ID = 'pl_user_id';
//# sourceMappingURL=constants.js.map